import React from 'react';

import { MODULES } from 'constants/ModuleConstants';

export const getConversationName = ({ customer, participants = [] }, intl, displayNameFormatter) => {
  if (customer) {
    const { phoneNumber } = customer;
    const tel = phoneNumber?.prefix && phoneNumber?.local ? `+${phoneNumber.prefix}${phoneNumber.local}` : undefined;

    if (customer.scheduler) {
      return intl.formatMessage({ id: 'page.chat.sections.bot', defaultMessage: 'Fleetback Bot' });
    }
    return displayNameFormatter(customer) || customer.email || tel || intl.formatMessage({ id: 'customer', defaultMessage: 'Customer' });
  }

  return participants.map((p) => displayNameFormatter(p)).join(', ');
};

export const getAvatarClassName = ({ customer, latestMessage }) => {
  if (customer) {
    if (customer.phoneNumber) {
      return 'phone';
    }

    if (customer.email) {
      return 'mail';
    }
  }

  if (latestMessage) {
    return getAvatarClassName({ customer: latestMessage.createdBy });
  }
  return undefined;
};

export const getAvatarIcon = ({ customer, latestMessage }) => {
  if (customer) {
    if (customer.phoneNumber) {
      return <span className="fb-icon fb-icon--phone" />;
    }

    if (customer.email) {
      return <span className="fb-icon fb-icon--mail" />;
    }

    if (customer.module) {
      return <i className={MODULES[customer.module].icon} />;
    }

    return undefined;
  }
  if (latestMessage) {
    return getAvatarIcon({ customer: latestMessage.createdBy });
  }
  return <span className="fb-icon fb-icon--management-user" />;
};

export const getCustomerAbbreviation = (customer, displayNameFormatter) => {
  if (customer?.scheduler) {
    return 'BOT';
  }
  if (customer?.displayName) {
    const abbr = displayNameFormatter(customer).split(' ').map(word => word[0]);
    return abbr.length > 1 ? `${abbr.shift()}${abbr.pop()}` : abbr.pop();
  }
  return undefined;
};
